export const isIphone = () => {
	return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};
